import { useModalStore } from '@/shared/lib';
import {
  PhoneVerificationContent,
  PhoneVerificationModal,
  PhoneVerificationTwoFactorIdentityModal,
  ResultModal,
} from '@/features/user-settings-phone/ui';
import type {
  PhoneVerificationModalArgs,
  PhoneVerificationTwoFactorIdentityModalArgs,
} from './types';
import { useTwoFactorModalAfterLogin } from '@/features/user-settings-2fa';
import { useSessionStore } from '@/entities/session';

const usePhoneVerificationModals = () => {
  const { session } = useSessionStore();
  const { showDialogComponent, closeDialog } = useModalStore();

  const {
    openTwoFactorAppEnableModal,
    isTwoFactorOptional,
    isTwoFactorRequired,
  } = useTwoFactorModalAfterLogin(session, true);

  const handleResultModalSubmit = () => {
    closeDialog();
    if (isTwoFactorRequired && !isTwoFactorOptional) {
      openTwoFactorAppEnableModal({
        showCloseButton: isTwoFactorOptional,
        preventOverlayClose: isTwoFactorRequired,
        onSuccess: closeDialog,
        ...(isTwoFactorOptional ? { onSkip: closeDialog } : {}),
      });
    }
  };

  const openPhoneVerificationModal = ({
    identity,
  }: PhoneVerificationModalArgs) => {
    showDialogComponent({
      component: (
        <PhoneVerificationModal
          identity={identity}
          onSuccess={data => {
            openPhoneVerificationTwoFactorIdentityModal(data);
          }}
          content={<PhoneVerificationContent />}
        />
      ),
      showCloseButton: false,
      preventOverlayClose: true,
    });
  };

  const openPhoneVerificationTwoFactorIdentityModal = ({
    identityType,
    identity,
    maskedContact,
    length,
    resendIn,
    expiresIn,
  }: PhoneVerificationTwoFactorIdentityModalArgs) => {
    showDialogComponent({
      component: (
        <PhoneVerificationTwoFactorIdentityModal
          identityType={identityType}
          onBack={() => {
            openPhoneVerificationModal({
              identity: identity,
            });
          }}
          maskedContact={maskedContact}
          length={length}
          resendIn={resendIn}
          expiresIn={expiresIn}
          identity={identity}
          onSuccess={openResultPhoneVerificationModal}
        />
      ),
      showCloseButton: false,
      preventOverlayClose: true,
    });
  };

  const openResultPhoneVerificationModal = () => {
    showDialogComponent({
      component: (
        <ResultModal
          onClose={handleResultModalSubmit}
          content={<PhoneVerificationContent isSuccess />}
        />
      ),
      onClose: handleResultModalSubmit,
      preventOverlayClose: false,
    });
  };

  return {
    openPhoneVerificationModal,
    openResultPhoneVerificationModal,
    openPhoneVerificationTwoFactorIdentityModal,
  };
};

export { usePhoneVerificationModals };
